import { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import styled from "styled-components";
import { Button, Dialog, Empty, SpinLoading } from "antd-mobile";
import useNavigation from "../../hooks/useNavigation";
import PageWrap from "../components/PageWrap";
import PageHeader, { headerHeight } from "../components/PageHeader";
import { useStores } from "../../models";
import { MyOrderCard } from "../../components/Wallet";
import useGlobalTheme from "../../hooks/useGlobalTheme";

const Body = styled.div`
  height: calc(100% - ${headerHeight});
  display: flex;
  flex-direction: column;
  min-height: 0;
`;

const Tabs = styled.div`
  flex-shrink: 0;
  display: flex;
  justify-content: space-around;
  padding-top: 10px;
  background: #fff;
`;

const ScrollArea = styled.div`
  flex: 1;
  min-height: 0;
  overflow: auto;
  background: #fff;
`;

const Tab = styled.div<{ $active?: boolean }>`
  position: relative;
  padding-bottom: 10px;
  cursor: pointer;
  color: ${({ $active, theme }) =>
    $active ? theme.colors.primary : theme.colors.secondaryText || "#999"};
  &::after {
    content: "";
    display: ${({ $active }) => ($active ? "block" : "none")};
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 15px;
    height: 3px;
    background: ${({ theme }) => theme.colors.primary};
  }
`;

const Footer = styled.div`
  flex-shrink: 0;
  height: 64px;
  display: flex;
  align-items: center;
  padding: 0 12px;
  background: #fff;
  border-top: 1px solid #eee;
`;

const MyOrderList = () => {
  const theme = useGlobalTheme();
  const { navigate } = useNavigation();
  const { orderStore, walletStore } = useStores();
  const [whichTab, setWhichTab] = useState(1);
  const [orders, setOrders] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const init = async () => {
    try {
      setLoading(true);
      const isSettled = whichTab === 2;
      const res = await orderStore.loadMyOrders(isSettled);
      const list = Array.isArray(res) ? res : res?.data || [];
      setOrders(list);
      await walletStore.loadPaymentList();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [whichTab]);

  return (
    <PageWrap>
      <PageHeader title="我的挂单" />
      <Body>
        <Tabs>
          <Tab $active={whichTab === 1} onClick={() => setWhichTab(1)}>
            进行中
          </Tab>
          <Tab $active={whichTab === 2} onClick={() => setWhichTab(2)}>
            已完成
          </Tab>
        </Tabs>
        <ScrollArea>
          {loading ? (
            <div style={{ display: "flex", justifyContent: "center", padding: 40 }}>
              <SpinLoading color={theme.colors.primary} />
            </div>
          ) : orders.length === 0 ? (
            <Empty description="暂无挂单" style={{ padding: 40 }} />
          ) : (
            orders.map((order) => (
              <MyOrderCard
                key={order.id || order.order_no}
                order={order}
                tab={whichTab}
                onRefresh={init}
              />
            ))
          )}
        </ScrollArea>
        <Footer>
          <Button
            color="primary"
            block
            onClick={() => {
              if (!walletStore.paymentList?.length) {
                Dialog.confirm({
                  title: "提示",
                  content: "请先绑定收款方式，再进行挂单",
                  confirmText: "前往绑定",
                  cancelText: "之后再说",
                  onConfirm: () => navigate("PayAccountManage"),
                });
              } else {
                navigate("MyOrderCreate");
              }
            }}
          >
            挂单
          </Button>
        </Footer>
      </Body>
    </PageWrap>
  );
};

export default observer(MyOrderList);
